import { createSelector } from "reselect";
import { selectUser } from "store/users/selectors";

export const selectFolder = (state) => state.folder || {};

export const selectFolderLoading = createSelector(
    [selectUser, selectFolder], 
    (user, folder) => folder.isLoading || user.modelDirLoading || user.commDirLoading);